import type {
  Oht2DFoupKind,
  Oht2DPalette,
  Oht2DStatus,
  Oht2DStatusColors,
} from './types';

/** Colors sampled from the product OHT reference illustration. */
export const OHT_COLORS = {
  outerFrame: '#1A202C',
  body: '#FFFFFF',
  bodyHighlight: '#F1F5F9',
  bodyShade: '#E2E8F0',
  innerPanel: '#1A202C',
  carriage: '#232A36',
  carriageSheen: '#3B4454',
  podText: '#1E293B',
  accent: '#4D79FF',
  logo: '#1E6FD9',
  rail: '#8E9AAF',
  hanger: '#1A202C',
  /** 2D carriers: single unified color. */
  foup: '#00CCFF',
  foupHighlight: '#7DE8FF',
  foupStroke: '#0369A1',
  foupProcessed: '#00CCFF',
  foupProcessedHighlight: '#7DE8FF',
  foupProcessedStroke: '#0369A1',
  idle: '#00E676',
  moving: '#3B82F6',
  transfer: '#F59E0B',
  error: '#EF4444',
  offline: '#94A3B8',
  selection: '#2563EB',
  hover: '#93C5FD',
  label: '#FFFFFF',
} as const;

export const OHT_2D_PALETTE: Oht2DPalette = {
  frame: OHT_COLORS.outerFrame,
  body: OHT_COLORS.body,
  highlight: OHT_COLORS.bodyHighlight,
  accent: OHT_COLORS.accent,
  panel: OHT_COLORS.innerPanel,
  label: OHT_COLORS.label,
  hanger: OHT_COLORS.hanger,
  foup: OHT_COLORS.foup,
  foupHighlight: OHT_COLORS.foupHighlight,
  foupStroke: OHT_COLORS.foupStroke,
  selection: OHT_COLORS.selection,
  hover: OHT_COLORS.hover,
};

export const OHT_2D_STATUS: Oht2DStatusColors = {
  idle: OHT_COLORS.idle,
  moving: OHT_COLORS.moving,
  transfer: OHT_COLORS.transfer,
  error: OHT_COLORS.error,
  offline: OHT_COLORS.offline,
};

export const OHT_2D_DEFAULT_WIDTH = 4.5;
export const OHT_2D_DEFAULT_HEIGHT = 5;

export const OHT_2D_SIMPLE_ZOOM = 0.45;

export function resolveOhtStatusColor(status: Oht2DStatus = 'idle'): string {
  return OHT_2D_STATUS[status] ?? OHT_2D_STATUS.idle;
}

/** Fill / highlight / stroke for a carried FOUP (single unified color). */
export function resolveOht2DFoupColors(_kind: Oht2DFoupKind = 'raw'): {
  fill: string;
  highlight: string;
  stroke: string;
} {
  return {
    fill: OHT_COLORS.foup,
    highlight: OHT_COLORS.foupHighlight,
    stroke: OHT_COLORS.foupStroke,
  };
}

export function mapSimPhaseToOhtStatus(
  phaseChip: 'travel' | 'deadhead' | 'wait' | 'idle' | undefined,
  opts?: { error?: boolean; offline?: boolean; transferring?: boolean }
): Oht2DStatus {
  if (opts?.offline) return 'offline';
  if (opts?.error) return 'error';
  if (opts?.transferring) return 'transfer';
  switch (phaseChip) {
    case 'travel':
    case 'deadhead':
      return 'moving';
    case 'wait':
      return 'transfer';
    case 'idle':
    default:
      return 'idle';
  }
}
